import { UpdateCroppingsCmd } from "./edit/editCmd"
import { FieldViewModel, IOmniaCommand, IOmniaShell, LocaleString, omniaResolve } from "./omnia"
import { IFieldsModuleContext } from "./types"

type Context = Omit<IFieldsModuleContext, "map" | "mapView">

export class EditCroppingCmd implements IOmniaCommand {

    text: LocaleString = "Set cropping information"
    icon: string = "edit"

    foreground = true

    constructor(private readonly ctxt: Context, private readonly shell: IOmniaShell, private readonly fieldId: number, private readonly year: number) {

    }

    execute() {

        const target = this.getTargetCropping()

        const p = target
            ? omniaResolve(target)
            : this.createCropping()

        p.then(c => {

            if (!c) {
                // TODO: erreur
                return
            }

            const editCmd = new UpdateCroppingsCmd(this.ctxt, "")

            return editCmd.execute(c)

        })

    }

    private getTargetCropping() {
        const field = this.ctxt.svc.findField(this.fieldId)
        return field && field.croppings.find(c => c.yearId == this.year)
    }

    private createCropping(): ng.IPromise<FieldViewModel> {

        const fieldId = this.fieldId

        return this.ctxt.svc
            .createDisabledCropping(fieldId, this.year)
            .then(() => this.getTargetCropping())

    }


}
